import React, { createContext, useState, useContext } from 'react';

// Переводы
const translations = {
    ru: {
        // Header
        about: 'О нас',
        catalog: 'Каталог',
        contacts: 'Контакты',
        consultation: 'консультация и заказ',

        // Contact Form
        contactFormTitle: 'Получить консультацию',
        contactFormSubtitle: 'Оставьте свои контакты и мы свяжемся с вами в течение 15 минут',
        nameLabel: 'Ваше имя',
        namePlaceholder: 'Введите ваше имя',
        phoneLabel: 'Номер телефона',
        phonePlaceholder: '+7 (___) ___-__-__',
        submitButton: 'Получить консультацию',
        closeButton: 'Закрыть',
        nameRequired: 'Пожалуйста, введите ваше имя',
        phoneRequired: 'Пожалуйста, введите номер телефона',
        phoneInvalid: 'Пожалуйста, введите корректный номер телефона',
        successMessage: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
        errorMessage: 'Произошла ошибка. Попробуйте еще раз.',

        // AI ChatBot
        aiDefaultResponse: 'Спасибо за вопрос! Наш специалист скоро ответит вам.',
        aiErrorResponse: 'Извините, произошла ошибка. Попробуйте позже или позвоните нам: +7 707 317 18 19',

        // Main Content
        tagline: 'Матрасы для идеального сна. Индивидуальный пошив и высокое качество.',
        comfort: 'Заботимся о вашем комфорте с первого шага',
        getConsultation: 'Получить консультацию',

        // Features
        freeDelivery: 'Бесплатная доставка',
        freeDeliveryDesc: 'Бесплатная доставка день в день, бесплатный выезд специалиста для правильного замера',
        individualComfort: 'Экологичность',
        individualComfortDesc: 'Полностью экологические материалы и сертифицированная продукция',
        qualityGuarantee: 'Гарантия качества',
        qualityGuaranteeDesc: 'До 10 лет и долгий срок службы',

        // Catalog Promo
        catalogSubtitle: 'Каталог матрасов',
        orthopedicMattresses: 'Ортопедические матрасы',
        promoText: 'Гарантия лучшей цены. Получи наматрасник или 2 подушки при покупке матраса',

        // Product Cards
        viewAndOrder: 'Заказать',
        springlessMattresses: 'Беспружинные матрасы',

        // Delivery
        delivery: 'Доставка по другим городам Казахстана',
        freeDeliveryKazakhstan: 'Срок доставки: от 7 до 14 рабочих дней',
        deliveryAlmaty: 'Доставка по г. Алматы',
        deliveryAlmatyDesc: 'Доставим ваш матрас в день заказа (при оформлении до 14:00).',
        deliveryOtherCities: 'Бесплатная доставка в любой населённый пункт страны',
        deliveryOtherCitiesDesc: 'Срок доставки: от 7 до 14 рабочих дней.',
        freeDeliveryCaption: 'Бесплатная доставка в любой населённый пункт страны',

        // Mobile short versions
        deliveryShort: 'Доставка',
        aboutShort: 'О нас',
        catalogShort: 'Каталог',

        // About Section
        aboutUs: 'О нас',
        aboutText: 'Компания AI-SON — завод по производству матрасов, успешно работающий на рынке с 2008 года. Компания специализируется на выпуске высококачественных ортопедических и анатомических матрасов. Мы обеспечиваем комфортный и здоровый сон, предлагая продукцию высочайшего качества и индивидуальный подход к каждому клиенту.',

        // About Features
        feature1Title: 'Шьём на профессиональных машинках.',
        feature1Text: 'Аккуратные швы и надёжность в каждой детали.',
        feature2Title: 'Производим сами — без посредников.',
        feature2Text: 'Контроль качества на каждом этапе.',
        feature3Title: 'Автономная работа каждой пружины.',
        feature3Text: 'Ортопедическая поддержка для комфортного сна.',
        feature4Title: 'Экологические материалы',
        feature4Text: 'Полностью экологические материалы и сертифицированная продукция',
        feature5Title: 'Работаем 24/7',
        feature5Text: 'Прием заказов 24/7. Мы работаем круглосуточно, без выходных и праздников. Консультация без выходных с 10:00-22:00',
        feature6Title: 'Расширение географии продаж',
        feature6Text: 'Постоянное расширение ассортимента и географии продаж',

        // Footer
        questionsRemain: 'Остались вопросы?',
        anyQuestions: 'Остались вопросы?',
        callUs: 'Звоните нам',
        whatsappMessage: 'Здравствуйте! Пишу с сайта AI-SON. Интересуют матрасы.',
        chatAnswer: 'Ответим на ваши вопросы 24/7 и оформим ваш заказ',
        chat: 'Чат',
        followSocial: 'Следите за нами в соцсетях',

        // Product Modal
        productModalTitle: 'Оставить заявку',
        productModalNameLabel: 'Ваше имя',
        productModalNamePlaceholder: 'Введите ваше имя',
        productModalPhoneLabel: 'Номер телефона',
        productModalPhonePlaceholder: '+7 (___) ___ - __ - ___',
        productModalPhoneError: 'Введите корректный номер в формате +7 (___) ___ - __ - ___',
        productModalSizeLabel: 'Выберите размер',
        productModalSizeVariants: 'вариантов',
        productModalSubmitButton: 'Рассчитать стоимость',
        productModalSubmitting: 'Отправляем...',
        productModalCharacteristic: 'Характеристика:',

        // Product Characteristics
        constructionType: 'Конструкция',
        stiffness: 'Жесткость',
        height: 'Высота',
        maxLoad: 'Нагрузка на 1 место',
        warranty: 'Гарантия',
        orthopedicEffect: 'Ортопедический эффект',
        features: 'Особенности',
        cover: 'Чехол',
        filler: 'Наполнитель',
        mainParameters: 'Ключевые параметры',
        composition: 'Состав матраса',
        yes: 'Есть',
        no: 'Нет',
        "side1": "1-ая сторона",
        "side2": "2-ая сторона",
        "springs": "Пружин на 1 место",

        productModalNameRequired: 'Пожалуйста, введите ваше имя',
        productModalPhoneRequired: 'Пожалуйста, введите номер телефона',
        productModalSizeRequired: 'Пожалуйста, выберите размер матраса',
        productModalPhoneInvalid: 'Пожалуйста, введите корректный номер телефона в формате +7 (___) ___ - __ - ___',
        productModalSuccessMessage: 'Спасибо! Мы свяжемся с вами в ближайшее время',
        productModalErrorMessage: 'Произошла ошибка. Попробуйте еще раз',
        productModalWarningMessage: 'Данные сохранены локально (Firestore недоступен)',

        productModalSelectSizePlaceholder: "Выберите размер",
        productModalOtherSize: "Другой размер",
        productModalCustomSizeLabel: "Введите свой размер",
        productModalCustomSizePlaceholder: "Например: 150x200 см",
        productModalCustomSizeRequired: "Пожалуйста, введите свой размер",

        aiAssistant: "AI Помощник",
        askQuestionPlaceholder: "Напишите ваш вопрос...",
        chatWelcome: "👋 **Добро пожаловать в AI-SON!**\nЯ ваш персональный AI-консультант.",
        chatInstruction: "Вы можете спросить меня о чем угодно:\n• Какие у вас есть матрасы?\n• Посоветуй матрас для двоих\n• Условия доставки по Астане",
        chatFormIntro: "Пожалуйста, представьтесь, чтобы мы могли сохранить историю нашего диалога и связаться с вами, если потребуется.",
        chatFormNameLabel: "Ваше имя",
        chatFormPhoneLabel: "Номер телефона",
        chatFormSubmitButton: "Отправить",
        chatFormSuccess: "Отлично, Спасибо. Теперь можете задать свой вопрос.",
        chatPhoneInvalid: "Неверный формат номера",

        // Desktop Video
        ourProduction: 'Наше производство',
        ourProductionDesc: 'Посмотрите, как мы создаем качественные матрасы для вашего комфорта',
        loadingVideo: 'Загрузка видео...',
        videoUnavailable: 'Видео временно недоступно',
        qualityMaterials: 'Качественные материалы',
        modernEquipment: 'Современное оборудование',
        fastProduction: 'Быстрое производство'
    },

    kz: {
        // Header
        about: 'Біз туралы',
        catalog: 'Каталог',
        contacts: 'Байланыс',
        consultation: 'кеңес беру және тапсырыс',

        // Contact Form
        contactFormTitle: 'Кеңес алу',
        contactFormSubtitle: 'Байланыс деректеріңізді қалдырыңыз, біз сізбен 15 минут ішінде байланысамыз',
        nameLabel: 'Сіздің атыңыз',
        namePlaceholder: 'Атыңызды енгізіңіз',
        phoneLabel: 'Телефон нөмірі',
        phonePlaceholder: '+7 (___) ___-__-__',
        submitButton: 'Кеңес алу',
        closeButton: 'Жабу',
        nameRequired: 'Атыңызды енгізіңіз',
        phoneRequired: 'Телефон нөміріңізді енгізіңіз',
        phoneInvalid: 'Дұрыс телефон нөмірін енгізіңіз',
        successMessage: 'Рахмет! Біз сізбен жақын арада байланысамыз.',
        errorMessage: 'Қате орын алды. Қайталап көріңіз.',

        // AI ChatBot
        aiDefaultResponse: 'Сұрағыңыз үшін рахмет! Біздің маман жақында сізге жауап береді.',
        aiErrorResponse: 'Кешіріңіз, қате орын алды. Кейінірек қайталап көріңіз немесе бізге қоңырау шалыңыз: +7 707 317 18 19',

        // Main Content
        tagline: 'Мінсіз ұйқы үшін матрастар. Жеке тігу және жоғары сапа.',
        comfort: 'Бірінші қадамнан бастап сіздің жайлылығыңысделать аз туралы қамқорлық жасаймыз',
        getConsultation: 'Кеңес алу',

        // Features
        freeDelivery: 'Тегін жеткізу',
        freeDeliveryDesc: 'Күні бойынша тегін жеткізу, дұрыс өлшеу үшін маманның тегін шығуы',
        individualComfort: 'Жеке жайлылық',
        individualComfortDesc: '1 күнде стандартты емес өлшемдерді тапсырыс бойынша дайындау',
        qualityGuarantee: 'Сапа кепілдігі',
        qualityGuaranteeDesc: '10 жылға дейін және ұзақ қызмет ету мерзімі',

        // Catalog Promo
        catalogSubtitle: 'Матрастар каталогы',
        orthopedicMattresses: 'Ортопедиялық матрастар',
        promoText: 'Ең жақсы бағаның кепілдігі. Матрас сатып алғанда наматрасник немесе 2 жастық алыңыз',

        // Product Cards
        viewAndOrder: 'Тапсырыс',
        springlessMattresses: 'Серіппесіз матрастар',

        // Delivery
        delivery: 'Жеткізу',
        freeDeliveryKazakhstan: 'Бүкіл Қазақстан бойынша тегін жеткізу',
        deliveryAlmaty: 'Алматы қаласы бойынша жеткізу',
        deliveryAlmatyDesc: 'Тапсырыс берген күні матрасыңызды жеткіземіз (14:00-ға дейін ресімдегенде).',
        deliveryOtherCities: 'Қазақстанның басқа қалаларына жеткізу',
        deliveryOtherCitiesDesc: 'Жеткізу мерзімі: 7-ден 14 жұмыс күніне дейін.',
        freeDeliveryCaption: 'Елдің кез келген елді мекеніне тегін жеткізу',

        // Mobile short versions
        deliveryShort: 'Жеткізу',
        aboutShort: 'Біз туралы',
        catalogShort: 'Каталог',

        // About Section
        aboutUs: 'Біз туралы',
        aboutText: 'AI-SON компаниясы — 2008 жылдан бері нарықта табысты жұмыс істеп келе жатқан матрас өндіру зауыты. Компания жоғары сапалы ортопедиялық және анатомиялық матрастар шығаруға мамандандырылған. Біз ең жоғары сапалы өнімдер мен әр клиентке жеке көзқарас ұсына отырып, жайлы және сау ұйқыны қамтамасыз етеміз.',

        // About Features
        feature1Title: 'Кәсіби машиналарда тігеміз.',
        feature1Text: 'Әр детальдағы таза тігістер мен сенімділік.',
        feature2Title: 'Өзіміз шығарамыз — аралықсыз.',
        feature2Text: 'Әр кезеңде сапаны бақылау.',
        feature3Title: 'Әр серіппенің автономды жұмысы.',
        feature3Text: 'Жайлы ұйқы үшін ортопедиялық қолдау.',
        feature4Title: 'Экологиялық материалдар',
        feature4Text: 'Толығымен экологиялық материалдар және сертификатталған өнімдер',
        feature5Title: '24/7 жұмыс істейміз',
        feature5Text: 'Тапсырыстарды 24/7 қабылдаймыз. Біз дүйсенбі мен мерекесіз, тәулік бойы жұмыс істейміз. Кеңес беру 10:00-22:00 аралығында мерекесіз',
        feature6Title: 'Сату географиясын кеңейту',
        feature6Text: 'Ассортимент пен сату географиясын үнемі кеңейту',

        // Footer
        questionsRemain: 'Сұрақтарыңыз бар ма?',
        anyQuestions: 'Сұрақтарыңыз\nбар ма?',
        callUs: 'Бізге қоңырау шалыңыз',
        whatsappMessage: 'Сәлеметсіз бе! AI-SON сайтынан жазып тұрмын. Матрастар қызықтырады.',
        chatAnswer: 'Сіздің сұрақтарыңызға 24/7 жауап береміз және тапсырысыңызды ресімдейміз',
        chat: 'Чат',
        followSocial: 'Әлеуметтік желілерде бізді бақылаңыз',

        // Product Modal
        productModalTitle: 'Өтініш қалдыру',
        productModalNameLabel: 'Сіздің атыңыз',
        productModalNamePlaceholder: 'Атыңызды енгізіңіз',
        productModalPhoneLabel: 'Телефон нөмірі',
        productModalPhonePlaceholder: '+7 (___) ___ - __ - ___',
        productModalPhoneError: 'Дұрыс нөмірді +7 (___) ___ - __ - ___ форматында енгізіңіз',
        productModalSizeLabel: 'Өлшемді таңдаңыз',
        productModalSizeVariants: 'нұсқа',
        productModalSubmitButton: 'Құнын есептеу',
        productModalSubmitting: 'Жіберілуде...',
        productModalCharacteristic: 'Сипаттамасы:',

        // Product Characteristics
        constructionType: 'Құрылыс',
        stiffness: 'Қаттылық',
        height: 'Биіктік',
        maxLoad: 'Жүктеме 1 орынға',
        warranty: 'Кепілдік',
        orthopedicEffect: 'Ортопедиялық әсер',
        features: 'Ерекшеліктер',
        cover: 'Жабын',
        filler: 'Толтырғыш',
        mainParameters: 'Негізгі параметрлер',
        composition: 'Матрас құрамы',
        yes: 'Бар',
        no: 'Жоқ',
        side1: "1-ші жағы",
        side2: "2-ші жағы",
        springs: "1 орынға серіппе саны",

        productModalNameRequired: 'Атыңызды енгізіңіз',
        productModalPhoneRequired: 'Телефон нөміріңізді енгізіңіз',
        productModalSizeRequired: 'Матрас өлшемін таңдаңыз',
        productModalPhoneInvalid: 'Дұрыс телефон нөмірін +7 (___) ___ - __ - ___ форматында енгізіңіз',
        productModalSuccessMessage: 'Рахмет! Біз сізбен жақын арада байланысамыз.',
        productModalErrorMessage: 'Қате орын алды. Қайталап көріңіз.',
        productModalWarningMessage: 'Деректер жергілікті түрде сақталды (Firestore қол жетімді емес)',


        productModalSelectSizePlaceholder: "Өлшемді таңдаңыз",
        productModalOtherSize: "Басқа өлшем",
        productModalCustomSizeLabel: "Өз өлшеміңізді енгізіңіз",
        productModalCustomSizePlaceholder: "Мысалы: 150x200 см",
        productModalCustomSizeRequired: "Өз өлшеміңізді енгізіңіз",

        aiAssistant: "AI Көмекші",
        askQuestionPlaceholder: "Сұрағыңызды жазыңыз...",
        chatWelcome: "👋 **AI-SON компаниясына қош келдіңіз!**\nМен сіздің жеке AI-кеңесшіңізбін.",
        chatInstruction: "Сіз менен кез келген нәрсені сұрай аласыз:\n• Cіздерде қандай матрастар бар?\n• Екі адамға арналған матрасқа кеңес беріңізші\n• Астана қаласына жеткізу шарттары қандай",
        chatFormIntro: "Сұхбат тарихын сақтау және қажет болған жағдайда сізбен байланысу үшін, өзіңізді таныстыруыңызды сұраймыз.",
        chatFormNameLabel: "Сіздің есіміңіз",
        chatFormPhoneLabel: "Телефон нөмірі",
        chatFormSubmitButton: "Жіберу",
        chatFormSuccess: "Керемет! Рахмет. Енді сұрағыңызды қойсаңыз болады.",
        chatPhoneInvalid: "Нөмір пішімі қате",

        // Desktop Video
        ourProduction: 'Біздің өндіріс',
        ourProductionDesc: 'Сіздің жайлылығыңыз үшін сапалы матрастарды қалай жасайтынымызды көріңіз',
        loadingVideo: 'Бейне жүктелуде...',
        videoUnavailable: 'Бейне уақытша қол жетімді емес',
        qualityMaterials: 'Сапалы материалдар',
        modernEquipment: 'Заманауи жабдықтар',
        fastProduction: 'Жылдам өндіріс'
    }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('ru'); // По умолчанию русский

    const t = (key) => {
        return translations[language][key] || key;
    };

    const switchLanguage = (lang) => {
        setLanguage(lang);
        // Добавляем класс к body для адаптивности дизайна
        document.body.className = document.body.className.replace(/\blang-\w+\b/g, '');
        document.body.classList.add(`lang-${lang}`);
    };

    // Устанавливаем начальный класс языка
    React.useEffect(() => {
        document.body.className = document.body.className.replace(/\blang-\w+\b/g, '');
        document.body.classList.add(`lang-${language}`);
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, switchLanguage, t, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
